import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const RecurringTransactionPrompt = ({ suggestion, onConfirm, onDismiss }) => {
  const { t } = useTranslation();
  if (!suggestion) return null;

  return (
    <div className="fixed bottom-4 right-4 bg-gray-800 shadow-lg rounded-lg p-4 max-w-sm animate-fadeInUp border border-blue-500/50 z-50">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <LucideIcons.Repeat size={24} className="text-blue-400" />
        </div>
        <div className="ml-3 flex-grow">
          <h3 className="text-sm font-semibold text-white">{t('recurringTransaction.title')}</h3>
          <p className="text-xs text-gray-300 mt-1">
            {t('recurringTransaction.description', { description: suggestion.description })}
          </p>
        </div>
      </div>
      <div className="mt-4 flex justify-end gap-2">
        <button onClick={onDismiss} className="px-3 py-1 text-xs font-bold text-gray-300 rounded-full hover:bg-gray-700 transition-colors">
          {t('recurringTransaction.dismiss')}
        </button>
        <button onClick={onConfirm} className="px-3 py-1 text-xs font-bold text-white bg-blue-600 rounded-full hover:bg-blue-700 transition-colors">
          {t('recurringTransaction.confirm')}
        </button>
      </div>
    </div>
  );
};

export default RecurringTransactionPrompt;
